/** Settings → Skills: the library, one skill, Customize, and the catalogue. */
export default {
  // Library
  searchSkills: "Search skills",
  showSkills: "Show skills",
  filterAll: "All",
  filterYours: "Your versions",
  filterIncluded: "Included",
  filterAdded: "Added",
  workProceduresNoun: "work procedures",
  executionSkillsNoun: "execution skills",
  noSkillsMatch: "No skills match your search.",
  noSkillsInView: "No skills in this view.",
  kindWork: "Work procedure",
  kindAgent: "Execution skill",
  notAssignedAutomatically:
    "Execution skills are not assigned to every agent automatically.",
  browseAllSkills: "Browse all skills",

  // One skill
  loadingSkill: "Loading skill…",
  skillUnavailable: "This skill is unavailable.",
  retry: "Retry",
  skills: "Skills",
  openYourVersion: "Open your version",
  customizeForMe: "Customize for me",
  editMyVersion: "Edit my version",
  whatYouNeed: "What you need",
  whatYouGet: "What you get",
  qualityChecks: "Quality checks",
  watchOutFor: "Watch out for",
  sources: "Sources",
  yourSteps: "Your steps",
  steps: "Steps",
  tip: "Tip: {tip}",
  tools: "Tools: {tools}",
  materials: "Materials: {materials}",

  // Customize
  sharedIntro:
    "Your version keeps Denker’s original intact. Change at least one step to create it.",
  personalIntro:
    "Changes to your version will be used when this process is selected for a task.",
  name: "Name",
  step: "Step {number}",
  saving: "Saving…",
  saveMyVersion: "Save my version",
  enterNameAndSteps: "Enter a name and text for every step.",
  cannotCustomize: "This skill cannot be customized yet.",
  saveFailed: "Could not save your skill.",

  // Catalogue
  skillCatalog: "Skill catalog",
  closeSkillCatalog: "Close skill catalog",
  searchCatalogSkills: "Search catalog skills",
  searchSkillsPlaceholder: "Search skills…",
  catalogError: "Could not load or add a skill.",
  loadingCatalog: "Loading catalog…",
  noMatchingSkills: "No matching skills",
  allSkillsAdded: "All skills added",
  add: "Add",
  adding: "Adding…",
  installedSkillsError: "Couldn’t load your installed skills.",
} as const;
